import React, { useState, useEffect } from "react";
import { observer, inject } from "mobx-react";
import TopBarMenu from "../../components/common/TopBarMenu";
import { useNavigate } from "react-router-dom";
import { getProjects } from "../../utils/api/Meeting/Dashboard/Project";

import { Box, Grid, Typography, Button } from "@mui/material";

const ProjectPage = ({ store }) => {
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    projectList();
  }, []);

  const projectList = async () => {
    store.setLoadingBarStatus(false);
    let projectListReq = await getProjects(store.baseUrl, store.token);
    if (projectListReq !== undefined && projectListReq !== null) {
      if (projectListReq.status === 200) {
        setProjects(projectListReq.data.data);
      } else if (projectListReq.status === 401) {
        store.setUserLogout();
        navigate("/panel/kullanici-girisi");
      }
    }
    store.setLoadingBarStatus(true);
  };

  return (
    <div className="container mps-container">
      <TopBarMenu meeting />
      <Box
        component="main"
        sx={{
          m: 4,
          mt: 10,
        }}
      >
        <Button
          onClick={() => navigate("/panel/personel")}
          variant={"contained"}
          style={{ margin: "6px", marginInlineStart: "0px" }}
        >
          Personeller
        </Button>
        <Button
          onClick={() => navigate("/panel/tema")}
          variant={"contained"}
          style={{ margin: "6px" }}
        >
          Temalar
        </Button>
        <Typography color="primary" sx={{ fontWeight: "bold" }}>
          {projects.length > 0 ? "Projeler" : "Aktif projeniz bulunmamaktadır"}
        </Typography>
      </Box>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          rowGap: "10px",
          columnGap: "10px",
          margin: "20px",
        }}
      >
        {projects.length > 0 &&
          projects.map((project, i) => (
            <Grid
              item
              sx={{
                borderRadius: "8px",
                boxShadow: "1px 1px 6px 0px rgba(0,0,0,0.75)",
                cursor: "pointer",
              }}
              onClick={() => {
                store.setProject(project);
                navigate("/panel");
              }}
              key={i}
            >
              <Box
                sx={{
                  height: 120,
                  padding: 2,
                }}
              >
                <Typography color="secondary" style={{ fontWeight: "bold" }}>
                  {project.name}
                </Typography>
              </Box>
            </Grid>
          ))}
      </div>
    </div>
  );
};

export default inject("store")(observer(ProjectPage));
